import c from "react";
import { getIconColor as g } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const i = {
  display: "block"
}, f = ({ size: a = 16, useVw: n, useRem: t, color: l, withColor: o, removeClassName: e, disableSSR: d, style: r, ...m }) => {
  const p = r ? { ...i, ...r } : i;
  return /* @__PURE__ */ c.createElement(x, { disableSSR: d }, /* @__PURE__ */ c.createElement("svg", { "data-icon-id": "32px-gangganwangge", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (t ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ c.createElement(
    "g",
    {
      className: e ? "" : "32px-æ æç½æ ¼"
    },
    /* @__PURE__ */ c.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: e ? "" : "normal",
        d: "M15.998 11.892a3.046 3.046 0 1 0 0-6.092 3.046 3.046 0 0 0 0 6.092Zm.898 1.717a4.851 4.851 0 0 0 3.865-3.863h5.74a.9.9 0 1 0 0-1.8h-5.74a4.848 4.848 0 0 0-9.525 0H5.5a.9.9 0 0 0 0 1.8h5.736a4.851 4.851 0 0 0 3.868 3.864.934.934 0 0 0-.004.082V26.2H9.54a.9.9 0 1 0 0 1.8h12.922a.9.9 0 0 0 0-1.8H16.9V13.692a.91.91 0 0 0-.004-.083ZM4.388 15.27c.472-.82 1.39-1.17 2.362-1.17h2.506c.97 0 1.887.352 2.36 1.17.472.818.317 1.789-.17 2.63l-1.257 2.167c-.485.84-1.249 1.46-2.193 1.46-.945 0-1.708-.62-2.193-1.46L4.54 17.894c-.477-.84-.626-1.81-.153-2.625ZM6.105 17l1.255 2.165c.294.507.556.56.636.56.08 0 .342-.053.635-.56l1.258-2.168c.292-.505.208-.759.168-.828-.04-.07-.218-.27-.801-.27H6.75c-.585 0-.764.2-.805.271-.042.072-.125.327.16.83Zm16.645-2.9c-.972 0-1.889.35-2.362 1.167-.473.816-.324 1.785.153 2.625l1.262 2.175c.485.84 1.248 1.458 2.193 1.458.944 0 1.708-.62 2.193-1.459l1.258-2.167c.486-.841.64-1.812.168-2.63-.472-.818-1.39-1.17-2.36-1.17H22.75Zm.61 5.065L22.105 17c-.285-.503-.202-.758-.16-.83.041-.071.22-.27.805-.27h2.506c.583 0 .76.199.8.269.04.07.125.323-.167.828l-1.258 2.168c-.293.507-.555.56-.635.56-.08 0-.342-.053-.636-.56Z",
        fillRule: "evenodd",
        fill: o ? g(l, 0, "#262933") : "#262933",
        datafollowfill: o ? g(l, 0, "#262933") : "#262933"
      }
    )
  )));
}, E = f;
export {
  E as default
};
